import React, { useCallback } from 'react';
import { ManagedPopup } from 'js/components/common/Popup';
import { useCombinedOnClose } from 'js/components/common/PopupManager';

import { TwoFactorAuthentication } from './components';

import style from './TwoFactorAuthenticationPopup.scss';

const popupClassNames = {
    inner: style.popupInner
};

const layerClassNames = {
    layout: style.layout
};

export const TwoFactorAuthenticationPopup = ({
    id,
    title,
    templateId,
    controls,
    onSuccess,
    resendHandler,
    onClose,
    onCancel
}) => {
    const closePopup = useCombinedOnClose(onClose, id);
    const cancelAndClose = useCallback(() => {
        closePopup();
        onCancel();
    }, [closePopup, onCancel]);

    return (
        <ManagedPopup
            controls={controls}
            onClose={cancelAndClose}
            className={style.container}
            classNames={popupClassNames}
            layerClassNames={layerClassNames}
        >
            <TwoFactorAuthentication
                title={title}
                onClose={closePopup}
                onSuccess={onSuccess}
                templateId={templateId}
                onCancel={cancelAndClose}
                resendHandler={resendHandler}
            />
        </ManagedPopup>
    );
};
